import { createSlice } from '@reduxjs/toolkit'

export const settingsPanelSlice = createSlice({
    name: 'settingsPanel',
    initialState: {
        isOpen: false,
        activeSection: null, // e.g. 'briefpapier', 'mitarbeiter', etc.
    },
    reducers: {
        toggleSettingsPanel: (state) => {
            state.isOpen = !state.isOpen
            if (!state.isOpen) {
                state.activeSection = null
            }
        },
        openSettingsPanel: (state) => {
            state.isOpen = true
        },
        closeSettingsPanel: (state) => {
            state.isOpen = false
            state.activeSection = null
        },
        setActiveSection: (state, action) => {
            state.activeSection = action.payload
        },
    }
})

export const { toggleSettingsPanel, openSettingsPanel, closeSettingsPanel, setActiveSection } = settingsPanelSlice.actions

export default settingsPanelSlice.reducer
